const SERVER = process.env.REACT_APP_DOMAIN;

export { SERVER };
